// extracted by mini-css-extract-plugin
export var grid = "sparkRegister-module--grid--1clz2";
export var copyGrid = "sparkRegister-module--copy-grid--2eC4Z";
export var copy = "sparkRegister-module--copy--bU-35";
export var embed = "sparkRegister-module--embed--AYhEL";
export var ctas = "sparkRegister-module--ctas--d4E1E";
export var heading = "sparkRegister-module--heading--3HAhj";